<div class="text-900 font-bold text-xl">
  <span>{{ dataLength() }}</span>
  <span> {{ entity() }}</span>
</div>
